import { render } from "./page1.vue?vue&type=template&id=b339df80&scoped=true"
import script from "./page1.vue?vue&type=script&lang=js"
export * from "./page1.vue?vue&type=script&lang=js"

import "./page1.vue?vue&type=style&index=0&id=b339df80&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b339df80"]])

export default __exports__